/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".md-form[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]{display:flex;align-items:center}.md-form[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .flex-grow-1[_ngcontent-%COMP%]{flex-grow:1}.md-form[_ngcontent-%COMP%]   .input-group[_ngcontent-%COMP%]   .mdb-select[_ngcontent-%COMP%]{width:100%}.md-form[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{height:100%;display:flex;align-items:center}"];
export { styles as styles };
